import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CMSService } from '../../services/cms-service';
import { environment } from 'environments/environment';
import { AdminService } from '../../services/admin';
import { Epidemimie } from 'model/modal-cms/epidemie';
import { Popup } from 'ng2-opd-popup';


@Component({
    selector: 'app-landing',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.scss']
})

export class LandingComponent implements OnInit {
  focus: any;
  focus1: any;
  list_epidemimie: any;
  urlfileIec = environment.urlfileIec;
  urlVideoIec = environment.urlVideoIec;
  source_video: any;
  titre:any ="Coronavirus";
  @ViewChild('popup5') popup5: Popup;
   @ViewChild('popupalert') popupalert: Popup;

  nbr_covid19: any;
  epidemimie: Epidemimie = new Epidemimie(null);
  date_covid19: Date;
  statistique_actu: string;
  urllogoIec = environment.urllogoIec;
 
  constructor(private router: Router,public cmsService: CMSService, private adminService: AdminService,) { 
    this.source_video = this.adminService.getevolution_default_video();
  }

  ngOnInit() {
      this.getinfoipdemie_actuel();
      this.EvolutionEpidemie();
  }

  login(){
	this.router.navigate(['home']);
   }


  iecInfoMedia(mot_cle:any){
	this.router.navigate(['iec-media/'+mot_cle]);
   }

   DetailsEpidemie(mot_cle:any){
    this.router.navigate(['iec-epidemie-info/'+mot_cle]);
   }

   EvolutionEpidemie() {
    this.cmsService.getevolutionepidemie()
      .subscribe(data => {
        this.list_epidemimie = data
      },
        err => {
          console.log(err);
        })
  }


  getinfoipdemie_actuel() {
    let etat = "ACTU"
    this.cmsService.getInfoEvolutionEpidemiebyetet(etat)
      .subscribe(data => {
        this.epidemimie = data
        this.nbr_covid19 = data.text_epid
        this.date_covid19 = this.epidemimie.date_ajout
        if(this.epidemimie.image_actu === null){
          this.statistique_actu = "alerte_corona.PNG";
        }else{
          this.statistique_actu = this.epidemimie.image_actu;         
        }
      },
        err => {
          console.log(err);
        })
  }

  getinfoipdemie() {
    let etat = "ACTU"
    this.cmsService.getInfoEvolutionEpidemiebyetet(etat)
      .subscribe(data => {
        this.epidemimie = data
        this.nbr_covid19 = data.text_epid
        this.date_covid19 = this.epidemimie.date_ajout
        if(this.epidemimie.image_actu === null){
          this.statistique_actu = "alerte_corona.PNG";
          this.popupnew();         
        }else{
          this.statistique_actu = this.epidemimie.image_actu;
          this.popupnew();
        }
      },
        err => {
          console.log(err);
        })
  }






  popupnew() {
    this.popup5.options = {
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-danger",
      color: "#FF0000",
      showButtons: true,
      animationDuration: 2,
      header: "ALERT COVID-19",
      widthProsentage: 50,
      animation: "fadeInUp",
      confirmBtnContent: "En savoir plus",
      cancleBtnContent: "Fermer",
    }

    this.popup5.show(this.popup5.options);

  }


    // popup detail
  popupnew2(id_epi: any) {
    this.cmsService.getInfoEvolutionEpidemie(id_epi)
    .subscribe(data => {
      this.epidemimie = data
      console.log(this.epidemimie.image_actu);
      if(this.epidemimie.image_actu == null){
        this.statistique_actu = "alerte_corona.PNG";
        this.getinfoipdemie_();
       
      }else{
        this.statistique_actu = this.epidemimie.image_actu;
        this.getinfoipdemie_();
      }
      // this.epidemimie.image_actu
      // this.epidemimie.date_ajout
      // this.epidemimie.text_epid
    
    },
      err => {
        console.log(err);
      })
  }


    getinfoipdemie_() {
    this.popupalert.options = {
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-danger",
      color: "#FF0000",
      showButtons: true,
      animationDuration: 2,
      header: "CENTRE DE COMMANDEMENT OPERATIONNRL COVID 19",
      widthProsentage: 60,
      animation: "fadeInUp",
      confirmBtnContent: "Autre",
      cancleBtnContent: "Fermer",
    }
    this.popupalert.show(this.popupalert.options);

  }


  voir() {
    this.router.navigate(['iec-epidemie-info/'+5]);
  }


   voir_() {
    this.popupalert.hide();
    this.epidemimie = new Epidemimie(null)
  }



   
}
